import I18n from '@module/i18n';

import Links from '@component/navigation/links';

const getThumbnailURL = (user) => {
  if (user.profile_picture && user.profile_picture.thumbnail_url) {
    return user.profile_picture.thumbnail_url;
  }
  return user.defaults.profile_picture_thumbnail_url;
};

const insertItemAfter = ({ index, items, item }) => {
  const clone = items.slice();
  clone.splice(index, 0, item);
  return clone;
};

export default {
  replaceProfileName: (navigation, contentKey) => {
    const name = contentKey.length > 0 ? I18n.t(contentKey) : '';
    return {
      ...navigation,
      account: {
        ...navigation.account,
        name,
      },
    };
  },
  removePlusPageLink: (navigation, itemKey) => {
    const updatedNavigation = { ...navigation };
    updatedNavigation[itemKey].items = updatedNavigation[itemKey].items.filter(
      (item) => {
        return item.path !== '/pro';
      }
    );
    return updatedNavigation;
  },
  attachSignoutLink: (navigation) => {
    return {
      ...navigation,
      account: {
        ...navigation.account,
        // Didn't use #push as it mutates the original object
        items: insertItemAfter({
          index: navigation.account.items.length,
          item: Links.signoutItem,
          items: navigation.account.items,
        }),
      },
    };
  },
  attachUpgradeLink: (navigation, device) => {
    if (device === 'desktop') {
      // Upgrade link is place before account menu in desktop
      const navigationClone = { ...navigation };
      const { account } = navigationClone;
      delete navigationClone.account;

      return {
        ...navigationClone,
        upgrade: Links.upgradeItem,
        account,
      };
    }

    if (device === 'mobile') {
      // Upgrade link is inside the account menu before Sign out link in mobile
      return {
        ...navigation,
        account: {
          ...navigation.account,
          items: insertItemAfter({
            index: navigation.account.items.length - 1,
            item: Links.upgradeItem,
            items: navigation.account.items,
          }),
        },
      };
    }

    // This should not happen, but in case the device condition wasn't catch properly don't break the navigation
    return navigation;
  },
  attachSignupLink: (navigation) => {
    const navigationClone = { ...navigation };
    const { account } = navigationClone;
    delete navigationClone.account;

    return {
      ...navigationClone,
      signup: {
        name: I18n.t('navigation.signup'),
        path: '/pro',
        queryParams: {
          trk: 'WT202005_signup',
        },
        trackEvent: {
          category: 'plus',
          action: 'click_upgrade',
        },
        whenActive: {
          /**
           * See the description of `fragment: 'pro-page-tiers-section'` in the
           * `app/views/page/plus.html.erb` for why is this here.
           * */
          fragment: 'pro-page-tiers-section',
          /**
           * This is explicitly undefined (any falsy value will work), otherwise
           * it would inherit parent's value — the value of `queryParams` of the
           * "parent" of this, `whenActive`, object.
           * This is important here because a user can appear on a /pro page not
           * only by clicking navigation item but also from other links
           * potentially having different query params values. In this case the
           * original query params must be preserved. Otherwise final url for
           * active state will have (different query params &&
           * `shouldBrowserHandle` set to `true`) which will lead to reloading
           * the page.
           *
           * For implementation details see
           * `app/javascript/component/navigation/navigation-item/navigation-item.js`.
           * */
          queryParams: undefined,
          shouldBrowserHandle: true,
        },
      },
      account,
    };
  },
  attachFeatureSpacesLink: (navigation) => {
    return {
      projects: Links.projectsItem,
      ...navigation,
    };
  },
  attachChannelName: (navigation, channelName) => {
    return {
      ...navigation,
      account: {
        ...navigation.account,
        name: channelName,
        hasChannelName: true,
      },
    };
  },
  attachAccountMenu: (navigation, user) => {
    // Basic account menu structure:
    // ---
    // Account:
    // |-- Transfer
    // |-- Contacts
    // |-- Profile
    // `-- Account

    return {
      ...navigation,
      account: {
        name: I18n.t('navigation.signed_in.name'),
        notificationDetails: ['onboarding_success', 'already_signed_in'],
        image: getThumbnailURL(user),
        items: [
          {
            ...Links.transfersItem,
            name: I18n.t('navigation.user.items.transfers'),
          },
          Links.contactsItem,
          Links.profileItem,
          Links.accountItem,
        ],
        hasChannelName: false,
      },
    };
  },
};
